export const watermarkTypes = {
  SmartSale: 'SmartSale',
}
